import "../style/Header.css";
import logoIcon from "../assets/imgs/logo.jpg";
import searchIcon from "../assets/icons/icons8-search.svg";
import { Link } from "react-router-dom";
/* import shopIcon from "../assets/icons/icons8-shop-64.png"; */



export const Header = () => {
  return (
    <>
      <header>
        <div className="top_head">
          <div className="logo">
            <img src={logoIcon} alt="Logo" />
          </div>
          <div className="icon">
            {/* <img src={shopIcon} alt="Shop Icon" /> */}
            <span ></span>
            <Link to={"Search"}><img src={searchIcon} alt="Search Icon" /></Link>

          </div>
        </div>
      </header>

    </>

  );
};
